import { Card, Col, Row } from "react-bootstrap";
import { useTranslation } from 'react-i18next';
import TiassistoElement from '../../TiAssisto/TiassistoElement';
import { OpportunityFunnelValues } from "../../../types";
import i18next from "i18next";

type OpportunityProps = OpportunityFunnelValues | any;

const OpportunitySmallPreview = ({ opportunity }: { opportunity: OpportunityProps }) => {

    const { t } = useTranslation()
    return (
        <Card >
            <Card.Body>
                <Card.Subtitle className="mb-2 text-muted">{t('opportunity_details')}</Card.Subtitle>
                <Card.Title>
                    {opportunity.entity ? (
                        <a href={'/opportunities/' + opportunity.entity.Id} target="_blank">{opportunity.name}</a>
                    ) : opportunity.name}
                </Card.Title>
                <Row className="mt-4">
                    <Col>
                        <b>{t('chanel')}</b><br />
                        {opportunity.Canale__c?.value ?? i18next.t('not_present')}
                    </Col>
                    <Col>
                        <b>{t('rental_company')}</b><br />
                        {opportunity.Noleggiatore__c?.value ?? i18next.t('not_present')}
                    </Col>
                    <Col>
                        <b>{t('commissions')}</b><br />
                        {opportunity.commissions}
                    </Col>
                    <Col>
                        <b>{t('typology')}</b><br />
                        {opportunity.Tipologia__c?.value ?? i18next.t('not_present')}
                    </Col>
                    <TiassistoElement>
                        <Col>
                            <b>{t('driver_mail')}</b><br />
                            {opportunity.driverEmail?.length ? opportunity.driverEmail : i18next.t('not_present')}
                        </Col>
                    </TiassistoElement>
                    <Col>
                        <b>{t('dealer')}</b><br />
                        {opportunity.nomePartner?.value ?? i18next.t('not_present')}
                    </Col>
                </Row>

				<Row className="mt-4">
					<Col>
						<b>{t('sales_user')}</b><br />
						{opportunity.salesUser ?? i18next.t('not_present')}
					</Col>
					<Col>
						<b>{t('reference_user')}</b><br />
						{opportunity.referenceUserLabel ?? i18next.t('not_present')}
					</Col>
					<Col>
						<b>{t('backup_users')}</b><br />
						{opportunity.backupUsers?.length ? opportunity.backupUsers.map((u: any) => u).join(', ') : i18next.t('not_present')}
					</Col>
				</Row>


                <Row className="mt-4">
                    <Col md={12}>
                        <b>{t('notes')}</b><br />
                        {opportunity.notes && opportunity.notes.length ? opportunity.notes : i18next.t('no_notes')}
                    </Col>
                </Row>

            </Card.Body>
        </Card>
    )
}

export default OpportunitySmallPreview;
